import { useAppointmentStore } from "../store/useAppointmentStore";
import { useChatStore } from "../store/useChatStore";
import { useCallback } from "react"; 
import { API_URLS } from "../constants/apiUrls";


export function useAppointmentScheduler() {
  const chatClient = useChatStore((state) => state.chatClient);
  const activeChannel = useChatStore((state) => state.activeChannel);
  const userDetails = useChatStore((state) => state.userDetails);
  const {
    setAppointmentDetails,
    setAppointmentSchedulePopup,
    setIframeUrl,
  } = useAppointmentStore();

  const scheduleAppointment = useCallback((event) => {
    if (event) {
      event.preventDefault?.();
      event.stopPropagation?.();
    }

    // Null safety for client, channel, and user details
    const primaryUser = chatClient?.user || null;
    const appointmentUser = userDetails?.secondary || null;
    const baseUrl = API_URLS.APP_VIEW_APPOINTMENT_IFRAME_URL;
    const token = activeChannel.cid;

    if (!primaryUser || !appointmentUser) {
      console.error("Appointment scheduling failed: Missing required data.", {
        primaryUser,
        appointmentUser,
      });
      return;
    }

    setAppointmentDetails({
      primaryUser,
      appointmentUser,
      activeChannel,
      messageId: null,
    });

    // Read iframe URL from the environment variable with null safety   
    if (! API_URLS.APP_APPOINTMENT_IFRAME_URL) {
      return;
    }

    // Null-safety check for token
    if (!token) {
      return baseUrl;
    }

    setIframeUrl(`${API_URLS.APP_APPOINTMENT_IFRAME_URL}?token=${encodeURIComponent(token)}`);
    setAppointmentSchedulePopup(true);
  }, [chatClient, userDetails, setAppointmentDetails, setAppointmentSchedulePopup, setIframeUrl]);

  return { scheduleAppointment };
}